var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxInvoicing",style:(_vm.fbackground()),attrs:{"id":"siActif"}},[_c('div',[_c('h5',[_c('router-link',{style:(_vm.fTxtColor()),attrs:{"to":_vm.linkGo}},[_vm._v(" "+_vm._s(_vm.title))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }